import React from 'react';

import List from '../List';
import Pill from '../Pill';

import { gaEventLabel, links } from '../../lib/constants';


const Tags = ({ tags, lpTag, lang, parentClassName, nonClickable, eventCategory, eventLabel, userId, userType }) => {

  return (
  <div className={parentClassName}>
    <List inline>{
      tags.map((t, i) => {
        return <Pill key={`tag.${i}`} label={t.name} 
        href={lpTag ? links.stemLPTag(t.query, lang) : links.searchByTag(t.query)} 
        icon="circle" isInternal nonClickable={nonClickable} 
        onTriggerEvents={() => window.dataLayer.push({
          'category': eventCategory,
          'label': eventLabel,
          'event': 'clicked_theme',
          'item_type': gaEventLabel.theme,
          'item_id': null,
          'item_value': t.name,
          'user_profile': userType,
          'user_id': userId || '00000'
        })} />
      })
    }</List>
    </div>
  );
};

export default Tags;


// WEBPACK FOOTER //
// ./src/components/Book/Tags.jsx